import type { AuditorSubmissionStatus } from '@/pages/screenata/policies/types'

export function getAuditorSubmissionStatusPresentation(status: AuditorSubmissionStatus) {
  switch (status) {
    case 'APPROVED':
      return {
        label: 'Approved by auditor',
        metaLabel: 'Approved',
        badgeClassName: 'bg-emerald-50 text-emerald-700',
      }
    case 'NEEDS_REVISION':
      return {
        label: 'Changes requested',
        metaLabel: 'Changes requested',
        badgeClassName: 'bg-amber-50 text-amber-700',
      }
    case 'SUPERSEDED':
      return {
        label: 'Superseded',
        metaLabel: 'Superseded',
        badgeClassName: 'bg-muted text-text-subtle',
      }
    default:
      return {
        label: 'Submitted',
        metaLabel: 'Submitted',
        badgeClassName: 'bg-blue-50 text-blue-700',
      }
  }
}
